/**
 * Local físico de atendimento — separa os avisos em tempo real quando o
 * mesmo médico atende em lugares diferentes com recepções diferentes, dentro
 * de UMA unidade só (spec 010 adiou unidade real).
 *
 * Mora na CONTA da recepção (`professionals/{uid}.serviceLocal`, Equipe),
 * não na máquina: a recepção de cada lugar tem o próprio login. O médico não
 * tem local fixo — o dele é deduzido dos pacientes que fizeram check-in hoje
 * (`QueueService.currentLocalOf`).
 */
export const SERVICE_LOCALS = [
  { id: 'CLINICA', label: 'Clínica' },
  { id: 'EXTERNO', label: 'Atendimento externo' },
] as const;

export function serviceLocalLabel(id: string | undefined): string | undefined {
  return SERVICE_LOCALS.find((l) => l.id === id)?.label;
}

/**
 * O aviso é de OUTRO lugar? Só quando os dois lados são conhecidos e
 * diferentes. Local desconhecido de qualquer lado mostra o aviso — melhor
 * sobrar pop-up do que sumir um paciente.
 */
export function isOtherLocal(mine: string | undefined, theirs: string | undefined): boolean {
  return !!mine && !!theirs && mine !== theirs;
}
